export default __webpack_public_path__ + "static/media/fence.94bfb8be.jpg";